<template>
  <div id="UsersSelect" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
        <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
          <div class="col-6 t-c color-primary" v-if="$route.query.user_type == 2"><span class="f24 fw">C</span>ajera(o)</div>
          <div class="col-6 t-c color-primary" v-else><span class="f24 fw">V</span>endedor</div>
          <div class="col-3 t-r f22 pr3"></div>
        </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(user,user_i) in data_list" v-bind:key="user_i" @click="set_user_args(user_i)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-12 pl10">
                <div class="col-12 f14 uppercase color-muted">{{ user.user_code }} </div>
                <div class="col-12 f14 fw uppercase pb2 el1">{{ user.user_name }}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UsersSelect',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.user_type = this.$route.query.user_type;
      this.post(this.api_url + 'manage/user_select', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.users;
        }else{
          this.data_list = []
        }
      })
    },
    set_user_args(i){
      let user_args = {};
      if(this.$route.query.user_type == 2){
        user_args.cashier_id = this.data_list[i].original_id
        user_args.cashier_name = this.data_list[i].user_name;
        this.$store.commit('setPageCashierArgs',user_args);
      }else{
        user_args.salesman_id = this.data_list[i].original_id;
        user_args.salesman_name = this.data_list[i].user_name;
        this.$store.commit('setPageSalesmanArgs',user_args);
      }
      this.$router.back(-1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/UsersSelect.vue